import color from "../../../../constants/color";

const styles ={
  card:{ backgroundColor: "#fff", 
    margin: 2,
    px:"30px",
    py:"30px",
    borderRadius: "20px",
    paddingBottom: "25px",
    "& .css-a5rdam-MuiGrid-root":{
      marginTop:"11px"
    },
   
  },
  heading:{
    fontSize:"20px",
    fontWeight:"600",
    pl:2
  },
  tableIcon: {
    borderBottom: 0, 
    display: "flex", 
    alignItems: "center" ,
  },
  name:{
    color:color.text,
    fontSize:"14px",
    fontWeight:"400",
    textTransform:"capitalize"

  },
  deleteIcon: {
    color:"#ff0000"
  },
  mail:{
    color:color.lightText,
    fontSize:"14px",
    fontWeight:"400"
  },  
  tableData: {
    borderBottom: 0, 

  },
  modalInput:{
    display:"flex",    // backgroundColor:color.lightGray,
    // width:{ xs: "25em", md: "35em" },
    justifyContent:"center" ,// Center align on smaller screens
    my:"10px",
    height:"2.5em",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":{
      padding:"0px 14px",

    },
    "& .MuiOutlinedInput-root":{
      padding:"0",
      borderRadius:"70px",

      '& .MuiChip-root':{
        backgroundColor:color.primary,
        color:color.lightText,
        fontSize:"12px"
      }
      
    },

     '& .MuiChip-root':{
        backgroundColor: 'transparent',
        color:color.lightText,
        fontSize:"12px",

        '& span':{
          paddingLeft:"0px"
        }
      }


  },
  inputSpace: {
    "& .MuiOutlinedInput-root":{
      padding:"0px 14px"
    }

  },
  label:{
    fontSize:"12px",
    fontWeight:"500" ,
    color:color.text,
  },
  calender:{
    ".css-6193sp-MuiInputBase-root-MuiOutlinedInput-root":{
      borderRadius:"8px",
      // width:{xs:"18em",sm:"18em",md:"20em",lg:"22em",xl:"25em"}
      width: "100%"
    }
  },
  TableHead: {
    color: color.lightText,
    fontWeight: "400",

  },
  tableAlign: { 
    display: "flex", 
    alignItems: "center", 
  },
  calenderInput:{
    mt:1,
    "& .MuiInputBase-input": {
      padding: "8.5px 10px 8.5px 8.5px",
    },
    width: "100%"

  },  
  btn: {
    borderRadius: 50,
    mt:3,
    textTransform:"none", 
    backgroundColor: "#28AA4A",
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator" :{
      position: "unset", 
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px", 
      marginLefts: "-8px", 
    },

  }
};
export default styles;